import {
  AllCommunityModule,
  ModuleRegistry,
  themeQuartz,
} from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

const compactParams = {
  spacing: 4,
  columnBorder: true,
  fontSize: 12,
};

export const agThemeLight = themeQuartz.withParams(compactParams);

export const agThemeDark = themeQuartz.withParams({
  ...compactParams,
  backgroundColor: '#1f2937',
  foregroundColor: '#f9fafb',
  headerBackgroundColor: '#374151',
  headerTextColor: '#d1d5db',
  borderColor: '#4b5563',
  rowHoverColor: '#374151',
  chromeBackgroundColor: '#1f2937',
});
